import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StoreModule } from '@ngrx/store';

import { CandidateFormSelectResolver } from './candidate-form-select.resolver';
import { CandidateFormModalComponent } from './container/candidate-form-modal.container';
import { candidateFormReducer } from './store/candidate-form.reducer';

export const modalRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: ':id',
        component: CandidateFormModalComponent,
        resolve: [CandidateFormSelectResolver]
      },
      {
        path: '',
        component: CandidateFormModalComponent,
        resolve: [CandidateFormSelectResolver]
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(modalRoutes),
    StoreModule.forFeature('candidateForm', candidateFormReducer)
  ],
  exports: [RouterModule],
  providers: [CandidateFormSelectResolver]
})
export class CandidateFormRoutingModule {}
